import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from "vue";
import { UsuarioSinEquipoDTO } from "@/interfaces/Usuario";
import { CreateMiembroEquipoDTO } from "@/interfaces/Inscripcion";
import { registrarMiembroEquipoAsync } from "@/services/InscripcionesService";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";

// Props y emits

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalAddMiembroEquipo',
  props: {
    isVisible: { type: Boolean },
    idEquipo: {},
    idTorneo: {},
    jugadores: {}
  },
  emits: ["update:isVisible", "close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// v-model bidireccional para isVisible
const visible = computed({
  get: () => props.isVisible,
  set: (val: boolean) => emit("update:isVisible", val),
});

const jugadorSelected = ref<UsuarioSinEquipoDTO>();
const isGenerating = ref(false);
const showSuccessModal = ref(false);
const showErrorModal = ref(false);

// Cerrar modal
const closeModal = () => {
  emit("update:isVisible", false);
  emit("close");
};

// Añadir jugador
const addJugador = async () => {
  try {
    isGenerating.value = true;

    const idTorneo = props.idTorneo;
    const idUsuario = jugadorSelected.value?.idUsuario;
    const idEquipo = props.idEquipo;

    if (!idTorneo || !idUsuario) {
      throw new Error("Faltan datos necesarios para registrar jugador");
    }

    const request: CreateMiembroEquipoDTO = {
      IdUsuario: idUsuario,
      IdTorneo: idTorneo,
      IdEquipo: idEquipo,
    };

    const response = await registrarMiembroEquipoAsync(request);

    const nuevoMiembro = {
      idUsuario: jugadorSelected.value!.idUsuario,
      nick: jugadorSelected.value!.nick,
      idInscripcion: response.idInscripcion,
      listaData: null,
      estadoLista: "NO ENTREGADA",
      ejercito: null,
      esCapitan: false,
      idLista: 0,
      fechaEntregaLista2: undefined,
    };

    showSuccessModal.value = true;
    emit("confirm", nuevoMiembro);
    closeModal();
  } catch (error) {
    console.error("Error al registrar jugador:", error);
    showErrorModal.value = true;
  } finally {
    isGenerating.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Agregar miembro al equipo")
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_combobox, {
                      modelValue: jugadorSelected.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((jugadorSelected).value = $event)),
                      items: props.jugadores,
                      "item-title": "nick",
                      "item-value": "idUsuario",
                      label: "Selecciona el jugador a añadir"
                    }, null, 8, ["modelValue", "items"]),
                    _createVNode(_component_v_row, {
                      justify: "center",
                      class: "my-4 ga-5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "primary",
                          onClick: addJugador,
                          large: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Agregar")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          onClick: closeModal,
                          large: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Cancelar")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Jugador añadido correctamente al equipo.",
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido añadir al jugador. Inténtelo de nuevo más tarde. Si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})